import { OrganizationRoleType } from "../../autogen/bff-api";

const creatorRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Admin,
  OrganizationRoleType.Owner,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.ContractCreator,
  OrganizationRoleType.ProjectCreator,
];

const orgEntryUpdateRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.ContractCreator,
];

export const organizationContractRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.ContractCreator,
  OrganizationRoleType.ContractViewer,
];

export const organizationSourcingRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
  OrganizationRoleType.SourcingViewer,
];

export const organizationEditSourcingRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.SourcingCreator,
];

export const organizationEditContractRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.ContractCreator,
];

export const organizationProjectRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.ProjectCreator,
  OrganizationRoleType.ProjectViewer,
];

export const organizationEditProjectRoles: OrganizationRoleType[] = [
  OrganizationRoleType.Owner,
  OrganizationRoleType.Admin,
  OrganizationRoleType.ProjectCreator,
];

export const isCreator = (roles: OrganizationRoleType[]) => creatorRoles.some((role) => roles.includes(role));

export const canUpdateOrgEntry = (roles: OrganizationRoleType[]) =>
  orgEntryUpdateRoles.some((role) => roles.includes(role));

export const hasSourcingViewAccess = (roles: OrganizationRoleType[]) =>
  roles.some((role) => organizationSourcingRoles.includes(role));

export const hasContractViewAccess = (roles: OrganizationRoleType[]) =>
  roles.some((role) => organizationContractRoles.includes(role));

export const hasProjectViewAccess = (roles: OrganizationRoleType[]) =>
  roles.some((role) => organizationProjectRoles.includes(role));

export const hasProjectCreateAccess = (roles: OrganizationRoleType[]) =>
  roles.some((role) => organizationEditProjectRoles.includes(role));

export const hasSourcingCreateAccess = (roles: OrganizationRoleType[]) =>
  roles.some((role) => organizationEditSourcingRoles.includes(role));

export const hasContractCreateAccess = (roles: OrganizationRoleType[]) =>
  roles.some((role) => organizationEditContractRoles.includes(role));
